import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box, Typography, Button, Dialog, DialogContent, IconButton,
  DialogActions, CircularProgress
} from '@material-ui/core';
import CustomPoper from '../CustomizedUIs/CustomPoper';
import { makeStyles } from '@material-ui/core';
import { useTranslate, useDataProvider } from 'react-admin';
import Field from '../CustomizedUIs/CustomTextFiled';

// Icons
import { Close, Add } from '@material-ui/icons';
import DialogEditScheduleMessage from './dialog-edit-schedule-message';
import TableScheduleMessageHeaders from './table-schedule-message-header';
import TableScheduleMessageItem from './table-schedule-message-item';
import TextButton from '../CustomizedUIs/TextButton';
import CloseButton from '../CustomizedUIs/CloseButton';

const useStyles = makeStyles(theme => ({
  dialogContent: {
    padding: '8px 40px'
  },
  list: {
    height: 255,
    backgroundColor: theme.palette.background.paper,
    overflow: 'auto',
  },
  button: {
    margin: theme.spacing(0.5, 0),
  },
  dialogCloseBtn: {
    // backgroundColor: theme.palette.common.white,
    marginLeft: 7,
    width: "25px",
    height: "25px",
    borderRadius: "10px",
    border: "solid 2px #e5f1f8",
    backgroundColor: " #ffffff",

  },
  dialogPaper: {
    minHeight: '90vh',
    maxHeight: '90vh',
    maxWidth: '650px',
    backgroundColor: theme.palette.background.default
  },
  boxBoder: {
    borderBottom: '1px solid',
    borderRight: '1px solid',
    borderBottomColor: theme.palette.grey['200'],
    borderRightColor: theme.palette.grey['200'],
  },
  input: {
    backgroundColor: 'white',
    borderRadius: '2px',
    "&:hover": {
      backgroundColor: 'white'
    },
    fontFamily: 'UniviaPro',
    fontSize: '13px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.85,
    letterSpacing: ' 0.13px',
    color: '#88898c',
  },
  inputMulti: {
    width: 525,
    borderRadius: '2px',
  },
  inputPopper: {
    alignSelf: 'flex-end',
    position: 'absolute',
    right: '16px',
    top: '20px'
  },
  send: {
    marginRight: '30px',
    width: '138px',
    height: '36px',
  },
  dialogActions: {
    paddingLeft: 32,
    paddingRight: 35,
    bottom: 0,
    right: 0,
  },
  divider: {
    marginTop: '14px'
  },
  btnClose: {
    fontFamily: " UniviaPro-Bold",
    fontSize: "10px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.4px",
    color: "#4f5064",
  },
  Title: {
    fontFamily: "UniviaPro-Medium",
    fontSize: "18px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.2,
    letterSpacing: "normal",
    color: "#4f5064",
    paddingBottom: "30px",
    marginTop: -10
  },

  btnSave: {
    fontFamily: 'UniviaPro-Bold',
    fontSize: ' 11px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: ' 0.44px',
    color: theme.palette.primary.main,
  },
  btnSend: {
    fontFamily: 'UniviaPro-Bold',
    fontSize: ' 11px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: ' 0.44px',
    color: '#ffffff',
  },
}));
let timeoutDeleted = null;
function DialogCreateEditSchedule({ open, onClose, schedule = null }) {
  const classes = useStyles();
  const translate = useTranslate();
  const dataProvider = useDataProvider();

  // STATE REGION
  const [name, setName] = useState('');
  const [messages, setMessages] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [openEditMessageDialog, setOpenEditMessageDialog] = useState(false);
  const [showSelectedHeader, setShowSelectedHeader] = useState([]);
  const [currentEditMessage, setCurrentEditMessage] = useState(null);
  const [currentEditIndex, setCurrentEditIndex] = useState(-1);
  const [checkall, setCheckAll] = useState(false);
  const [isDate, setIsDate] = useState(false);
  const [error, setError] = useState({
    name: {
      isError: false,
      message: ""
    }
  });
  // END STATE REGION

  const textOnChange = prop => (e) => {
    setName(e.target.value)
    validate(prop, e.target.value)
  }

  const validate = (prop, value) => {
    if (value.length === 0)
      setError({
        ...error, [prop]: value.length === 0 ? {
          isError: true, message: translate('pos.messages.required')
        } : {
            isError: false, message: ''
          }
      })
    else {
      setError({
        ...error, [prop]: {
          isError: false, message: ''
        }
      })
    }
  }

  const handleClickOpenPoper = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosePoper = () => {
    setAnchorEl(null);
  };

  const onSubmit = () => {
    setSubmitting(true);
    const data = {
      name,
      scheduleMessages: messages
    };

    if (schedule) {
      dataProvider('UPDATE', 'schedule-template', {
        id: schedule.id,
        data
      }).then(res => {
        console.log('Update schedule success:', res);
        setSubmitting(false);
        onClose(true);
        clearState();
      }).catch(error => {
        // TODO: Should show error message
        console.error('Update schedule error:', error);
        setSubmitting(false);
      });
    } else {
      dataProvider('CREATE', 'schedule-template', {
        data
      }).then(res => {
        console.log('Create schedule success:', res);
        setSubmitting(false);
        onClose(true);
        clearState();
      }).catch(error => {
        // TODO: Should show error message
        console.error('Create schedule error:', error);
        setSubmitting(false);
      });
    }
  }

  const clearState = () => {
    setName('');
    setCheckAll(false);
    setShowSelectedHeader([]);
    setMessages([]);
    setError({
      name: {
        isError: false,
        message: ""
      }
    });
  }

  const close = () => {
    clearState();
    onClose();
  }

  const disableCreateButton = () => {
    if (name === '') return true;
    return false;
  }

  const onEnter = () => {
    if (schedule) {
      setName(schedule.name);
      const newData = schedule.scheduleMessages.map(item => ({
        ...item,
        isDate: item.day === '0' ? true : false,
        checked: false
      }));
      setMessages(newData);
    }
  }

  const addMessage = (scheduleMessage, index = -1) => {
    scheduleMessage.checked = false;
    if (index !== -1) {
      let newMessages = [...messages];
      newMessages[index] = scheduleMessage;
      setMessages(newMessages);
    } else {
      let newMessages = [...messages];
      newMessages.push(scheduleMessage);
      setMessages(newMessages);
    }
  }

  const onCloseDialog = () => {
    setOpenEditMessageDialog(false);
    setCurrentEditMessage(null);
    setCurrentEditIndex(-1);
  }

  const checkIsDate = () => {
    messages.map(item => {
      if (parseInt(item.day) === 0 && item.hour === 0 && item.minute === 0)
        setIsDate(true)
    })
  }

  const openEditScheduleMessageDialog = (index) => {
    checkIsDate()
    const selectedMessage = messages[index];
    if (selectedMessage) {
      setCurrentEditMessage(selectedMessage);
      setCurrentEditIndex(index);
      setOpenEditMessageDialog(true);
    } else {
      // TODO: Out of range error
    }
  }

  const onCheckAll = (e) => {
    const newMessages = messages.map(item => {
      if (checkall === false) {
        return {
          ...item,
          checked: true
        }
      }
      else {
        return {
          ...item,
          checked: false
        }
      }
    });
    const selectedItems = newMessages.filter(item => item.checked);
    const isCheckAll = selectedItems.length === newMessages.length;
    setCheckAll(isCheckAll);

    setMessages(newMessages);
    setShowSelectedHeader(selectedItems);


  }

  const onDeleteMany = () => {
    const newMessages = messages.filter(item => !item.checked);
    setShowSelectedHeader([]);
    setMessages(newMessages);
  }

  const onCheck = (id) => {
    const newMessages = messages.map(item => ({
      ...item,
      checked: item.id === id ? !item.checked : item.checked
    }));
    let isCheckAll = newMessages.filter(item => item.checked).length === messages.length;
    setCheckAll(isCheckAll);
    setMessages(newMessages)
    const newSelectedItems = newMessages.filter(item => item.checked);
    setShowSelectedHeader(newSelectedItems);
  }

  const onDeleteOne = (index) => {
    let newMessages = [...messages];
    newMessages.splice(index, 1);
    setMessages(newMessages);
    setShowSelectedHeader([]);
  }

  const createNewMessage = () => {
    setOpenEditMessageDialog(true)
    checkIsDate()
  }

  const openPoper = anchorEl !== null;
  return (
    <Dialog open={open} fullWidth scroll='paper' classes={{ paper: classes.dialogPaper }} onEnter={onEnter}>
      <Box mx={5} mt={3}>
        <Box display='flex' justifyContent='flex-end' alignItems='center'>
          <Typography className={classes.btnClose}>{translate(`pos.user.close`)}</Typography>
            <CloseButton onClick={onClose} />
        </Box>
        {
          schedule ?
            <Typography className={classes.Title}>{translate(`resources.messages.editSchedule`)}</Typography> :
            <Typography className={classes.Title}>{translate(`resources.messages.createSchedule`)}</Typography>
        }
      </Box>
      <DialogContent className={classes.dialogContent}>
        <Box mx={2.5}>
          <Field
            onBlur={() => {
              validate('name', name)
            }}
            required
            id="name"
            label={translate(`resources.customers.fields.name`)}
            value={name}
            onChange={textOnChange('name')}
            error={error.name.message != "" && error.name.isError}
            helperText={error.name.message}
            style={{ width: 525 }}
            endDom={<CustomPoper
              open={openPoper}
              anchorEl={anchorEl}
              handleClick={handleClickOpenPoper}
              handleClose={handleClosePoper}
              title={translate(`resources.customers.fields.name`)}
              content={translate(`pos.messages.nameSchedule`)}
              icon={<b>?</b>}
            />}
          />
        </Box>
        <Box mt={3} mx={2.5} alignItems='right'>
          <Button variant='contained' color='primary' onClick={() => createNewMessage()}>
            <Typography className={classes.btnSend}>{translate('resources.messages.createMessage')}</Typography>
            <Add />
          </Button>
        </Box>
        {
          messages.length > 0 ?
            <Box mt={3} mx={2.5}>
              <TableScheduleMessageHeaders
                showSelectedHeader={showSelectedHeader}
                onCheckAll={onCheckAll}
                onDelete={onDeleteMany}
                checkall={checkall}
                onCheck={onCheck}
              />
              {
                messages &&
                <Box style={{ maxHeight: "50vh", overflow: 'auto' }}>
                  {
                    messages.map((item, index) =>
                      <TableScheduleMessageItem
                        key={item.id + ''}
                        item={item}
                        onCheck={onCheck}
                        onDelete={() => onDeleteOne(index)}
                        onEdit={() => openEditScheduleMessageDialog(index)}
                      />
                    )
                  }
                </Box>
              }
            </Box> : null
        }
        <DialogEditScheduleMessage
          open={openEditMessageDialog}
          onClose={onCloseDialog}
          addMessage={addMessage}
          scheduleMessage={currentEditMessage}
          index={currentEditIndex}
          isDate={isDate}
          setIsDate={setIsDate}
        />
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <TextButton mr={2} style={{ marginTop: "1em" }} onClick={close} />
     

        <Button
          disabled={submitting || disableCreateButton()}
          variant="contained"
          className={classes.send}
          size="large"
          color="primary"
          onClick={onSubmit}
        >
          {
            submitting ? (
              <CircularProgress
                size={25}
                thickness={2}
                color='inherit'
              />
            ) : <Typography className={classes.btnSend}>{translate('pos.common.save')}</Typography>
          }
        </Button>
      </DialogActions>
    </Dialog>
  );
}

DialogCreateEditSchedule.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  schedule: PropTypes.object,
};

export default DialogCreateEditSchedule;
